import React, { useCallback, useMemo } from 'react';
import { identity } from 'lodash-es';
import { TRANSLATION_NAMESPACE } from './_settings/constants';
import Message from './components/Message';
var IS_ADDING_NESTED_TRANSLATION = false;
var IS_OVERRIDING_EXISTING_NAMESPACE = false;
export var TmsUIContext = /*#__PURE__*/React.createContext({
  setDefaultTranslations: identity,
  translate: identity
});
var DEFAULT_I18N_ATTRS = {
  addResourceBundle: identity,
  language: 'en',
  t: identity
};

var TmsUIProvider = function TmsUIProvider(_ref) {
  var children = _ref.children,
      _ref$i18n = _ref.i18n,
      i18n = _ref$i18n === void 0 ? DEFAULT_I18N_ATTRS : _ref$i18n,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  // Set custom translations for UI components. It will still use 'common'
  // namespace

  /**
   * Set custom translations for UI components and will use `common` namespace.
   * It wont override the original translation if any. Sometimes it worked with
   * useEffect hook, but its recommended to invoke this function directly
   * since it won't override anything anyway.
   *
   * @param {object} languageBundle - language bundle translation.
   *
   * @example
   * const languageBundle = {
   *   en: {
   *     foo: 'Foo'
   *   },
   *   id: {
   *     foo: 'fu',
   *   },
   * }
   * setDefaultTranslations(languageBundle);
   */
  var setDefaultTranslations = useCallback(function () {
    var languageBundle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var language = i18n.language,
        addResourceBundle = i18n.addResourceBundle;
    addResourceBundle(language, TRANSLATION_NAMESPACE, languageBundle[language], IS_ADDING_NESTED_TRANSLATION, IS_OVERRIDING_EXISTING_NAMESPACE);
  }, [i18n]); // https://github.com/i18next/i18next/issues/1287#issuecomment-604273657

  var translate = i18n.t.bind(i18n);
  var value = useMemo(function () {
    return {
      setDefaultTranslations: setDefaultTranslations,
      translate: translate
    };
  }, [setDefaultTranslations, translate]);
  return /*#__PURE__*/React.createElement(TmsUIContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(Message.GlobalStyle, {
    isMobile: isMobile
  }), children);
};

export default TmsUIProvider;